import { Text } from '@betty/moonlight'

import styles from './TrustPilotSection.module.css'

import TrustPilotWidget from '../TrustPilotWidget/TrustPilotWidget'

function TrustPilotSection() {
  return (
    <div className={styles.trustPilotWrapper}>
      <Text variant='h4' gradient="darkSurfaceAccent">
        Ontario loves Betty!
      </Text>
      <Text variant='body-m' color="darkSurfacePrimary">
        2800+ slot games, instant withdrawals, no wagering requirements, human
        support.
      </Text>
      <TrustPilotWidget height='unset' templateId='53aa8912dec7e10d38f59f36' />
    </div>
  )
}

export default TrustPilotSection
